import { useSelector } from 'react-redux';
import { getTransactionsSearchSelector } from 'store/selectors/transactions';

import { prepareProjectData, PROJECT_TABS } from './helper';
import { getAgentTeamRoleSelector } from 'store/selectors/agentTeamDetail';

import { useState } from 'react';

import { ProjectsTable } from './ProjectsTable';
import { ArchiveDropdown } from 'pages/Workshop/components/ArchiveDropdown';
import { TabLabel } from 'pages/Workshop/components/TabLabel';
import { WorkshopPageTabs } from 'pages/Workshop/components/WorkshopPageTabs';

export const ProjectTabs = (tabItemsProps) => {
  const { userRole, className, loading } = tabItemsProps;

  const agentRole = useSelector(getAgentTeamRoleSelector);
  const isSearchApplied = useSelector(getTransactionsSearchSelector);

  const [archivedValue, setArchivedValue] = useState('');
  const [activeKey, setActiveKey] = useState(PROJECT_TABS.AtRisk);

  const dataItems = prepareProjectData({
    ...tabItemsProps,
    agentRole,
    isSearchApplied,
  });

  const { atRisk, inProgress, upcoming, onHold, archivedProjects } = dataItems;

  const getArchivedDataSource = () => {
    if (archivedValue === PROJECT_TABS.Closed) return archivedProjects.closed;

    if (archivedValue === PROJECT_TABS.Cancelled) return archivedProjects.cancelled;

    if (archivedValue === PROJECT_TABS.Expired) return archivedProjects.expired;

    return [];
  };

  const getArchivedOptions = () => {
    const { closed, cancelled, expired } = archivedProjects;

    return [
      { label: 'Closed', count: loading ? null : closed.length },
      { label: 'Canceled', count: loading ? null : cancelled.length },
      { label: 'Expired', count: loading ? null : expired.length },
    ];
  };

  const tabItems = [
    {
      key: PROJECT_TABS.AtRisk,
      label: <TabLabel title={'At Risk'} count={loading ? null : atRisk.length} />,
      children: <ProjectsTable dataSource={atRisk} userRole={userRole} loading={loading} />,
    },
    {
      key: PROJECT_TABS.InProgress,
      label: <TabLabel title={'In Progress'} count={loading ? null : inProgress.length} />,
      children: <ProjectsTable dataSource={inProgress} userRole={userRole} />,
    },
    {
      key: PROJECT_TABS.Upcoming,
      label: <TabLabel title={'Upcoming'} count={loading ? null : upcoming.length} />,
      children: <ProjectsTable dataSource={upcoming} userRole={userRole} />,
    },
    {
      key: PROJECT_TABS.OnHold,
      label: <TabLabel title={'On Hold'} count={loading ? null : onHold.length} />,
      children: <ProjectsTable dataSource={onHold} userRole={userRole} />,
    },
    {
      key: PROJECT_TABS.Archive,
      label: (
        <ArchiveDropdown
          archivedValue={archivedValue}
          setArchivedValue={(value) => {
            setArchivedValue(value);
            setActiveKey(PROJECT_TABS.Archive);
          }}
          archivedData={getArchivedDataSource()}
          dropdownOptions={getArchivedOptions()}
        />
      ),
      children: archivedValue ? (
        <ProjectsTable
          archivedValue={archivedValue}
          dataSource={getArchivedDataSource()}
          userRole={userRole}
        />
      ) : null,
    },
  ];

  return (
    <WorkshopPageTabs
      activeKey={activeKey}
      items={tabItems}
      onChange={(value) => {
        if (archivedValue && value !== PROJECT_TABS.Archive) {
          setArchivedValue('');
        }

        value !== PROJECT_TABS.Archive && setActiveKey(value);
      }}
    />
  );
};
